import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onCreateJob,
  onDeleteJob,
  onGetJob,
  onGetPagedAllJobs,
  onGetPagedAllJobsForAdmin,
  onGetPagedAllJobsForGraduates,
  onUpdateJob,
  onUpdateJobForAdmin,
} from '../../../app/modules/company-and-job/components/jobs/core/_requests'
import {
  onGetCompanies,
  onGetConfirmationStatuses,
  onGetJobLocationTypes,
  onGetJobTypes,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface JobState {
  AllJobs: any
  job: any
  jobTypes: any
  jobLocationTypes: any
  companies: any
  confirmationStatuses: any
  isLoading: boolean
}
const initialState = {
  AllJobs: [],
  job: null,
  jobTypes: [],
  jobLocationTypes: [],
  companies: [],
  confirmationStatuses: [],
  isLoading: true,
} as JobState

export const fetchJobConfirmationStatuses = createAsyncThunk(
  'company/fetchJobConfirmationStatuses',
  async () => {
    const data: any = await onGetConfirmationStatuses()
    return data.data.result.items
  }
)

export const fetchJobTypes = createAsyncThunk('job/fetchJobTypes', async () => {
  const data: any = await onGetJobTypes()
  return data.data.result.items
})

export const fetchJobLocationTypes = createAsyncThunk('job/fetchJobLocationTypes', async () => {
  const data: any = await onGetJobLocationTypes()
  return data.data.result.items
})

export const fetchCompanies = createAsyncThunk('job/fetchCompanies', async () => {
  const data: any = await onGetCompanies()
  return data.data.result.items
})

export const fetchAllJobs = createAsyncThunk('job/fetchAllJobs', async (param: any) => {
  const data: any = await onGetPagedAllJobs(param)
  return data.data.result
})

export const fetchAllJobsForGraduates = createAsyncThunk(
  'job/fetchAllJobsForGraduates',
  async (param: any) => {
    const data: any = await onGetPagedAllJobsForGraduates(param)
    return data.data.result
  }
)

export const fetchAllJobsForAdmin = createAsyncThunk(
  'job/fetchAllJobsForAdmin',
  async (param: any) => {
    const data: any = await onGetPagedAllJobsForAdmin(param)
    return data.data.result
  }
)

export const updateJobForAdmin = createAsyncThunk(
  'company/updateJobForAdmin',
  async (param: any) => {
    const data: any = await onUpdateJobForAdmin(param)
    return data.data
  }
)

export const fetchJob = createAsyncThunk('job/fetchJob', async (param: any) => {
  const data: any = await onGetJob(param)
  return data.data.result
})

export const updateJob = createAsyncThunk('job/updateJob', async (param: any) => {
  const data: any = await onUpdateJob(param)
  return data.data
})

export const createJob = createAsyncThunk('job/createJob', async (param: any) => {
  const data: any = await onCreateJob(param)
  return data.data
})

export const deleteJob = createAsyncThunk('job/deleteJob', async (param: any) => {
  const data: any = await onDeleteJob(param)
  return data.data
})

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    clearAllJobs: (state) => {
      state.AllJobs = []
    },
    clearJob: (state) => {
      state.job = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllJobs.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllJobs.fulfilled, (state: any, action) => {
      state.AllJobs = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAllJobs.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchAllJobsForAdmin.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllJobsForAdmin.fulfilled, (state: any, action) => {
      state.AllJobs = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAllJobsForAdmin.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchAllJobsForGraduates.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllJobsForGraduates.fulfilled, (state: any, action) => {
      state.AllJobs = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAllJobsForGraduates.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchJob.fulfilled, (state: any, action) => {
      state.job = action.payload
    })
    builder.addCase(fetchJobTypes.fulfilled, (state: any, action) => {
      state.jobTypes = action.payload
    })
    builder.addCase(fetchJobLocationTypes.fulfilled, (state: any, action) => {
      state.jobLocationTypes = action.payload
    })
    builder.addCase(fetchCompanies.fulfilled, (state: any, action) => {
      state.companies = action.payload
    })
    builder.addCase(fetchJobConfirmationStatuses.fulfilled, (state: any, action) => {
      state.confirmationStatuses = action.payload
    })
  },
})

export const {clearAllJobs, clearJob, activateLoading} = jobSlice.actions

export default jobSlice.reducer
